import React from 'react';
import './App.scss';
import { Router } from './routes';

function App() {
  return (
    <div className={'y-app'}>
      <Router />
    </div>
  );
}

export default App;
